import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Base unica per il teardown delle subscription: espone `destroy$` (un `Subject<void>`) da usare
 * con `takeUntil(this.destroy$)`. `ngOnDestroy` emette e completa. È la base canonica dell'app;
 * `UnsubscribeOnDestroy` è mantenuto come alias di questa classe per i sottoscrittori esistenti.
 * Il valore emesso è `void`: i consumatori usano solo `takeUntil`, quindi il payload è irrilevante.
 * `destroy$` è `public` (non `protected`) per consentire anche gli usi dai template/figli legacy.
 */
@Injectable()
export abstract class DestroyingComponent implements OnDestroy {

  destroy$: Subject<void> = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
